module.exports = __webpack_public_path__ + "static/media/reset-password.1c59fe9a.svg";